
  <p-splitButton
    [ngClass]="classes"
    [label]="text"
    [styleClass]="styleClass"
    [disabled]="disabled"
    [model]="primeModels"
    (onClick)="onClick.emit($event)"
    (onDropdownClick)="onDropdownClick.emit($event)"></p-splitButton>
  